import { Suspense } from "react";
import {
  isBasicPostsSpace,
  isFeedViewImageSpace,
  isGridOrMasonryViewImageSpace,
  isMembersSpace,
  shouldShowSpaceContent,
} from "@/react/helpers/spaceHelpers";
import { BlocksViewer } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/BlocksViewer/BlocksViewer";
import { useGetLockscreenBlocks } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/hooks";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PostViewList = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PostViewList" */ "@circle-react/components/PostsV3/PostViewList"
    ),
);

const ImageGridViewComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ImageGridViewComponent" */ "@circle-react/components/Spaces/ImageSpace/GridView"
    ),
);

const MembersSpaceContentComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MembersSpaceContentComponent" */ "@circle-react/components/Spaces/MembersSpace/Content"
    ),
);

export interface ContentProps {
  activeViewType?: string;
  isLockedSpace?: boolean;
  space: any;
  spaceResource: any;
}

export const Content = ({
  space,
  isLockedSpace,
  spaceResource,
  activeViewType,
}: ContentProps) => {
  const blocks = useGetLockscreenBlocks(spaceResource);

  if (!shouldShowSpaceContent(space)) {
    return null;
  }

  if (isLockedSpace) {
    return <BlocksViewer blocks={blocks} />;
  }

  if (isBasicPostsSpace(space) || isFeedViewImageSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <PostViewList />
      </Suspense>
    );
  }

  if (isGridOrMasonryViewImageSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <ImageGridViewComponent />
      </Suspense>
    );
  }

  if (isMembersSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <MembersSpaceContentComponent activeViewType={activeViewType} />
      </Suspense>
    );
  }

  return null;
};
